import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import { Modal, ListGroup, ListGroupItem } from 'react-bootstrap';
import _ from 'lodash';
import url from 'url';
import path from 'path';
import axios from 'axios';
import download from 'downloadjs';

import ConfirmationModal from '../ConfirmationModal.jsx';

import styles from '../../styles/variables.scss';

import { removeFromGroup } from '../../actions/form';

export class ReusableTable extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = {
      quickFilterText: null,
      modal: '',
    };

    this.onGridReady = this.onGridReady.bind(this);
    this.checkPropData = this.checkPropData.bind(this);
    this.bindDocumentActions = this.bindDocumentActions.bind(this);
    this.bindContactsActions = this.bindContactsActions.bind(this);
    this.bindReferencesActions = this.bindReferencesActions.bind(this);
    this.bindHistoriesActions = this.bindHistoriesActions.bind(this);
    this.bindExperienceActions = this.bindExperienceActions.bind(this);
    this.setColumnDefs = this.setColumnDefs.bind(this);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  setColumnDefs() {
    const columnDefs = [];
    _.each(this.props.columnDefs, (defs) => {
      columnDefs.push(defs);
    });

    return columnDefs;
  }

  deleteDocument(index) {
    // TODO: move this into a saga
    if (this.props.documents[index]) {
      // build delete resource url
      const reqUrl = url.format({
        pathname: path.join(APP_CONFIG.api, 's3-delete'), // eslint-disable-line no-undef
        query: {
          fileName: this.props.documents[index].url.split('/').pop(),
        },
      });
      // delete from s3
      return axios.get(reqUrl)
        .then(() => this.props.removeFromGroup('documents', index))
        .catch((err) => { // eslint-disable-line no-unused-vars
        // do something with err
        });
    }

    return false;
  }

  confirmDeleteDocument(index) {
    const updates = this.state;
    const show = true;
    function close() {
      this.closeModal();
    }
    function deleteAndClose() {
      this.deleteDocument(index);
      this.closeModal();
    }
    const closeModal = close.bind(this);
    const deleteData = deleteAndClose.bind(this);
    updates.modal = (
      <ConfirmationModal
        showModal={show}
        onConfirm={deleteData}
        onClose={closeModal}
        title="Delete"
        message="Are you sure you want to delete this document?"
        confirmText="Delete"
        confirmClass="danger"
      />
    );
    this.setState(updates);
  }

  closeModal() {
    const updates = this.state;
    updates.modal = '';
    this.setState(updates);
  }

  download(index) {
    download(this.props.documents[index].url);
  }

  bindDocumentActions(data, index) {
    const action = {
      deleteHandler: this.confirmDeleteDocument.bind(this, index),
      downloadHandler: this.download.bind(this, index, data),
    };
    return _.assign(data, { action });
  }

  bindContactsActions(data, index) {
    const action = {
      viewHandler: this.viewContact.bind(this, index),
      editHandler: this.props.editHandler.bind(this, index),
      deleteHandler: this.confirmDeleteContact.bind(this, index),
    };
    return _.assign(data, { action });
  }

  bindReferencesActions(data, index) {
    const action = {
      viewHandler: this.viewReference.bind(this, index),
      editHandler: this.props.editHandler.bind(this, index),
      deleteHandler: this.confirmDeleteReference.bind(this, index),
    };
    return _.assign(data, { action });
  }

  bindHistoriesActions(data, index) {
    const action = {
      viewHandler: this.viewHistory.bind(this, index),
      editHandler: this.props.editHandler.bind(this, index),
      deleteHandler: this.confirmDeleteHistory.bind(this, index),
    };
    return _.assign(data, { action });
  }

  bindExperienceActions(data, index) {
    const action = {
      viewHandler: this.viewExperience.bind(this, index),
      editHandler: this.props.editHandler.bind(this, index),
      deleteHandler: this.confirmDeleteExperience.bind(this, index),
    };
    return _.assign(data, { action });
  }

  viewContact(index) {
    const updates = this.state;
    const contact = this.props.contacts[index];
    const show = true;
    const closeModal = this.closeModal.bind(this);
    const title = _.upperCase(contact.name);
    updates.modal = (
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderContactView(index)}</Modal.Body>
      </Modal>
    );
    this.setState(updates);
  }

  deleteContact(index) {
    if (this.props.contacts[index]) this.props.removeFromGroup('contacts', index);
  }

  confirmDeleteContact(index) {
    const updates = this.state;
    const contact = this.props.contacts[index];
    const show = true;
    function close() {
      this.closeModal();
    }
    function deleteAndClose() {
      this.deleteContact(index);
      this.closeModal();
    }
    const closeModal = close.bind(this);
    const deleteContact = deleteAndClose.bind(this);
    updates.modal = (
      <ConfirmationModal
        showModal={show}
        onConfirm={deleteContact}
        onClose={closeModal}
        title="Delete Contact"
        message={`Are you sure you want to delete the contact ${contact.name}?`}
        confirmText="Delete"
        confirmClass="danger"
      />
    );
    this.setState(updates);
  }

  viewExperience(index) {
    const updates = this.state;
    const show = true;
    const closeModal = this.closeModal.bind(this);
    updates.modal = (
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>View Racing Experience</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderExperienceView(index)}</Modal.Body>
      </Modal>
    );
    this.setState(updates);
  }

  deleteExperience(index) {
    if (this.props.experiences[index]) this.props.removeFromGroup('racingExperience', index);
  }

  viewHistory(index) {
    const updates = this.state;
    const show = true;
    const closeModal = this.closeModal.bind(this);
    updates.modal = (
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>View Team Experience</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderHistoryView(index)}</Modal.Body>
      </Modal>
    );
    this.setState(updates);
  }

  confirmDeleteHistory(index) {
    const updates = this.state;
    const history = this.props.histories[index];
    const show = true;
    function close() {
      this.closeModal();
    }
    function deleteAndClose() {
      this.deleteHistory(index);
      this.closeModal();
    }
    const closeModal = close.bind(this);
    const deleteHistory = deleteAndClose.bind(this);
    updates.modal = (
      <ConfirmationModal
        showModal={show}
        onConfirm={deleteHistory}
        onClose={closeModal}
        title="Delete Team Experience"
        message={`Are you sure you want to delete the team experience ${history.raceTeam}?`}
        confirmText="Delete"
        confirmClass="danger"
      />
    );
    this.setState(updates);
  }

  deleteHistory(index) {
    if (this.props.histories[index]) this.props.removeFromGroup('histories', index);
  }

  confirmDeleteExperience(index) {
    const updates = this.state;
    const show = true;
    function close() {
      this.closeModal();
    }
    function deleteAndClose() {
      this.deleteExperience(index);
      this.closeModal();
    }
    const closeModal = close.bind(this);
    const deleteExperience = deleteAndClose.bind(this);
    updates.modal = (
      <ConfirmationModal
        showModal={show}
        onConfirm={deleteExperience}
        onClose={closeModal}
        title="Delete Experience"
        message="Are you sure you want to delete this race experience?"
        confirmText="Delete"
        confirmClass="danger"
      />
    );
    this.setState(updates);
  }

  viewReference(index) {
    const updates = this.state;
    const reference = this.props.references[index];
    const show = true;
    const closeModal = this.closeModal.bind(this);
    const title = _.upperCase(reference.name);
    updates.modal = (
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderReferenceView(index)}</Modal.Body>
      </Modal>
    );
    this.setState(updates);
  }

  deleteReference(index) {
    if (this.props.references[index]) this.props.removeFromGroup('references', index);
  }

  confirmDeleteReference(index) {
    const updates = this.state;
    const reference = this.props.references[index];
    const show = true;
    function close() {
      this.closeModal();
    }
    function deleteAndClose() {
      this.deleteReference(index);
      this.closeModal();
    }
    const closeModal = close.bind(this);
    const deleteReference = deleteAndClose.bind(this);
    updates.modal = (
      <ConfirmationModal
        showModal={show}
        onConfirm={deleteReference}
        onClose={closeModal}
        title="Delete Reference"
        message={`Are you sure you want to delete the reference ${reference.name}?`}
        confirmText="Delete"
        confirmClass="danger"
      />
    );
    this.setState(updates);
  }

  checkPropData() {
    if (this.props.experiences) {
      return this.configureExperienceRowData(this.props.experiences);
    }

    if (this.props.contacts) {
      return this.configureContactsRowData(this.props.contacts);
    }

    if (this.props.documents) {
      return this.configureDocumentsRowData(this.props.documents);
    }

    if (this.props.references) {
      return this.configureReferencesRowData(this.props.references);
    }

    if (this.props.histories) {
      return this.configureHistoriesRowData(this.props.histories);
    }

    return false;
  }

  configureDocumentsRowData(propData) {
    const rowData = [];
    _.each(propData, (data, index) => {
      rowData.push(this.bindDocumentActions(data, index));
    });
    return rowData;
  }

  configureReferencesRowData(propData) {
    const rowData = [];
    _.each(propData, (data, index) => {
      rowData.push(this.bindReferencesActions(data, index));
    });
    return rowData;
  }

  configureHistoriesRowData(propData) {
    const rowData = [];
    _.each(propData, (data, index) => {
      rowData.push(this.bindHistoriesActions(data, index));
    });
    return rowData;
  }

  configureContactsRowData(propData) {
    const rowData = [];
    _.each(propData, (data, index) => {
      rowData.push(this.bindContactsActions(data, index));
    });
    return rowData;
  }

  configureExperienceRowData(propData) {
    const rowData = [];
    _.each(propData, (data, index) => {
      rowData.push(this.bindExperienceActions(data, index));
    });
    return rowData;
  }

  renderContactView(index) {
    const contact = this.props.contacts[index];
    const contactList = [];
    if (!contact) return '';
    const itemMap = _.map(contact, (value, prop) => ({ prop, value }));
    _.forEach(itemMap, (data, i) => {
      if (!_.isObject(data.value)) {
        contactList.push(<ListGroupItem key={i}>{ _.capitalize(data.prop) }: { data.value }</ListGroupItem>);
      }
    });

    return (
      <ListGroup>
        {contactList}
      </ListGroup>
    );
  }

  renderReferenceView(index) {
    const reference = this.props.references[index];
    const referenceList = [];
    if (!reference) return '';
    const itemMap = _.map(reference, (value, prop) => ({ prop, value }));
    _.forEach(itemMap, (data, i) => {
      if (!_.isObject(data.value)) {
        referenceList.push(<ListGroupItem key={i}>{ _.startCase(data.prop) }: { data.value }</ListGroupItem>);
      }
    });
    return (
      <ListGroup>
        {referenceList}
      </ListGroup>
    );
  }

  renderHistoryView(index) {
    const history = this.props.histories[index];
    const historyList = [];
    if (!history) return '';
    const itemMap = _.map(history, (value, prop) => ({ prop, value }));
    _.forEach(itemMap, (data, i) => {
      if (!_.isObject(data.value)) {
        historyList.push(<ListGroupItem key={i}>{ _.startCase(data.prop) }: { data.value }</ListGroupItem>);
      }
    });
    return (
      <ListGroup>
        {historyList}
      </ListGroup>
    );
  }

  renderExperienceView(index) {
    const experience = this.props.experiences[index];
    const experienceList = [];
    if (!experience) return '';
    const itemMap = _.map(experience, (value, prop) => ({ prop, value }));
    _.forEach(itemMap, (data, i) => {
      if (!_.isObject(data.value)) {
        experienceList.push(<ListGroupItem key={i}>{ _.startCase(data.prop) }: { data.value }</ListGroupItem>);
      }
    });
    return (
      <ListGroup>
        {experienceList}
      </ListGroup>
    );
  }

  render() {
    const data = this.checkPropData();
    const columnDefs = this.setColumnDefs();

    return (
      <React.Fragment>
        <div id="reusable-table" className="ag-theme-dark">
          {this.state.modal}
          <AgGridReact
            onGridReady={this.onGridReady}
            columnDefs={columnDefs}
            rowData={data}
            rowSelection="none"
          />
        </div>

        <style jsx global>{`
          #reusable-table {
            width: 100%;
            height: 200px;
            margin-right: 15px;
            margin-top: 8px;
            margin-bottom: 8px;

            .table-btn {
              background: none;
              border: none;
              margin: 0 10px;
              padding: 0;

              &:hover {
                background: none;
                border: none;
              }
            }
          }

          .ag-overlay-panel >
          .ag-overlay-no-rows-wrapper >
          .ag-overlay-no-rows-center {
            background: none;
            border: none;
            border-radius: ${styles.defaultBorderRadius};
          }

          .ag-theme-dark {
            .ag-header-cell {
              background: ${styles.grey};
            }

            .ag-header-cell-label {
              background: ${styles.grey};
            }

            .ag-cell-focus {
              box-shadow: none !important;
              outline: none;
              appearance: none;
              border: none !important;
            }

            .ag-row {
              border-bottom: 1px solid ${styles.lighterGrey};
              color: ${styles.lighterGrey};
            }

            .ag-cell {
              border-right: 1px solid ${styles.lighterGrey} !important;
            }

            .ag-row-even,
            .ag-row-odd {
              background: ${styles.darkGrey} !important;
            }
          }

          .ag-body-viewport-wrapper {
            background: ${styles.darkGrey};
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default connect(
  null,
  { removeFromGroup },
)(ReusableTable);

ReusableTable.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.shape({})),
  experiences: PropTypes.arrayOf(PropTypes.shape({})),
  documents: PropTypes.arrayOf(PropTypes.shape({})),
  references: PropTypes.arrayOf(PropTypes.shape({})),
  histories: PropTypes.arrayOf(PropTypes.shape({})),
  columnDefs: PropTypes.arrayOf(PropTypes.shape({})),
  editHandler: PropTypes.func,
};
